/* 环境配置文件
 ** 根据全局 process.env.VUE_APP_API_ENV 变量进行判断
 ** 在 package.json 的 scripts 中做了 VUE_APP_API_ENV 配置
 */

 const env = {
    development: {
      // apiHost: 'http://192.168.5.203/',
      // serveUrl: 'https://erp.ellassay.com/',
      // apiHost: 'https://erp.ellassay.com/',
      serveUrl: 'http://192.168.205.77/',
      apiHost: 'http://192.168.205.77/',
      // serveUrl: 'http://testerp.ellassay.com:8085/',
      // apiHost: 'http://testerp.ellassay.com:8085/',
      // serveUrl: 'http://testerp.ellassay.com:8085/',
  
      // serveUrl: 'http://testerp.ellassay.com:8081/index.php/',
      // apiHost: 'http://testerp.ellassay.com:8081/index.php/',
      // serveUrl: 'http://testerp.ellassay.com:8081/index.php/',
      // apiHost: 'http://192.168.0.35:999/index.php/',
      // serveUrl: 'http://192.168.0.35:999/index.php/',
      baseRouter: '',
      // appId: ''
    },
    test: {
      apiHost: 'http://192.168.0.35:998/index.php/api/',
      serveUrl: 'http://192.168.0.35:998/index.php/api/',
      baseRouter: '',
    },
    production: {
      apiHost: ' https://erp.ellassay.com/',
      serveUrl: ' https://erp.ellassay.com/',
      baseRouter: '',
    }
  };
//   const envConfig = env[process.env.VUE_APP_API_ENV];
const envConfig = env[process.env.NODE_ENV].apiHost
  export default envConfig;


// WEBPACK FOOTER //
// ./src/request/env.js